import React from 'react'
import PropTypes from 'prop-types'

export default class StatusItem extends React.Component {

  static propTypes = {
    text: PropTypes.string.isRequired,
    icon: PropTypes.string,
    style: PropTypes.object
  }

  render() {
    return (
      <div style={{ ...styles.container, ...this.props.style }}>
        { this.props.icon
          ? <img src={this.props.icon} width={56} height={56} />
          : <div style={{ width: 56, height: 56 }}></div>
        }
        <div style={styles.text}>
          { this.props.text }
        </div>
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  text: {
    fontFamily: 'Roboto',
    fontSize: 18,
    lineHeight: 1.11,
    color: '#4a4a4a',
    marginLeft: 18
  }

}



// WEBPACK FOOTER //
// ./src/login/StatusItem.js